import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import InvList from "./inv/list/InvList";
import InvDetail from "./inv/detail/InvDetail";
import InvCreate from "./inv/create/InvCreate";
import IncomingCreate from "./incoming/create/IncomingCreate";
import InvHistory from "./inv/history/InvHistory";
import OutgoingCreate from "./outgoing/create/OutgoingCreate";
import AdjustmentCreate from "./adjustment/create/AdjustmentCreate";
import History from "./history/History";
import AnalyzeList from "./analyze/list/AnalyzeList";
import AnalyzeFormula from "./analyze/formula/AnalyzeFormula";
import { Barcode } from "./barcode/Barcode";

export default function Inventory() {
    const { key } = useLocation()

    return <Routes>
        <Route key={key} path={"inv/list"} element={<InvList />} />
        <Route key={key} path={"inv/create"} element={<InvCreate />} />
        <Route key={key} path={"inv/detail/:id"} element={<InvDetail />} />
        <Route key={key} path={"inv/history/:id"} element={<InvHistory />} />
        <Route key={key} path={"barcode"} element={<Barcode />} />
        <Route key={key} path={"incoming/create"} element={<IncomingCreate />} />
        <Route key={key} path={"outgoing/create"} element={<OutgoingCreate />} />
        <Route key={key} path={"adjustment/create"} element={<AdjustmentCreate />} />
        <Route key={key} path={"history"} element={<History />} />
        <Route key={key} path={"analyze/list"} element={<AnalyzeList />} />
        <Route key={key} path={"analyze/formula"} element={<AnalyzeFormula />} />
        <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
    </Routes>
}